import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import {getToken} from '@/utils/auth'
import router from "@/router";

// 创建axios实例

console.log(process.env,'process.env.BASE_API');

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api', // 设置默认值，避免undefined
  timeout: 60000 // 请求超时时间
})

let flag_401 = true;

// request拦截器
request.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers["Authorization"] = ` Bearer ${token}`;
  } else {
    config.headers['Authorization'] = ""
  }
  return config
  }, error => {
  // Do something with request error
  console.log("请求错误",error) // for debug
  Promise.reject(error)
})

// respone拦截器
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 根据自定义错误码处理错误
    if (res.errCode !== 0) {
      Message({
        message: res.message || "请求失败",
        type: "error",
        duration: 5 * 1000,
      });
      // 401: 未授权
      if (res.errCode === 401) {
        // 清除所有存储数据
        localStorage.clear();
        sessionStorage.clear();
        // 避免重复导航到当前页面
        if (router.currentRoute.path !== '/login') {
          router.push("/login");
        }
      }

      return Promise.reject(new Error(res.message || "请求失败"));
    } else {
      return res.data || res;
    }
  },
  (error) => {
    if (error.status === 401) {
      Message({
        message: error.response.data.message || "请求失败",
        type: "error",
        duration: 5 * 1000,
      });
      setTimeout(() => {
        // 清除所有存储数据
        localStorage.clear();
        sessionStorage.clear();
        // 避免重复导航到当前页面
        if (router.currentRoute.path !== '/login') {
          router.push("/login");
        }
      }, 3000);
    }
  }
);

function deleteEmptyProperty(obj) {
  var object = obj;
  for (var i in object) {
    var value = object[i];
    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        if (value.length == 0) {
          delete object[i];
          continue;
        }
      }
      deleteEmptyProperty(value);
    } else {
      if (value === '' || value === null || value === undefined) {
        delete object[i];
      }
      // if (value === null || value === undefined) {
			// 	delete object[i];
			// }
    }
  }
  return object;
}

function getRequest(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'GET');
}

function getRequestJson(url, params, bool= true) {
  let pm
  if (bool) {
      pm = deleteEmptyProperty(params);
  } else {
      pm = params
  }
  return request_fuc(url, pm, 'GET', 1);
}

function postRequest(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'POST');
}

function postRequestJson(url, params, bool= true) {
  let pm
  if (bool) {
      pm = deleteEmptyProperty(params);
  } else {
      pm = params
  }
  return request_fuc(url, pm, 'POST', 1);
}

function request_fuc(url, params, method, isJson, responseType) {
  // 根据URL设置不同的Content-Type
  let contentType = 'application/x-www-form-urlencoded; charset=UTF-8'
  if (isJson && isJson === 1) {
    contentType = 'application/json'
  }
  if (url === '/common/oss/getSignUrl') {
    contentType = 'application/octet-stream'
  }
  
  return request({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' || method === 'DELETE' ? (isJson == 1 ? JSON.stringify(params) : params) : null,
    params: method === 'GET' ? params : null,
    // 请求头携带信息，类型默认为form,键值模式，传参为1
    headers: {
      'Content-Type': contentType,
    },
    responseType: responseType || 'json' // 动态设置 responseType，默认为 'json'
  })
}

function downloadFile(url, params) {
  let pm = deleteEmptyProperty(params);
  return request_fuc(url, pm, 'GET', 0, 'blob'); // 设置 responseType 为 'blob'
}



// 同时导出整个对象，包含所有方法
export default  {
  request,
  getRequest,
  getRequestJson,
  postRequest,
  postRequestJson,
  downloadFile,
}
